import { useDictionary } from "@adamlip/okeoke.client";
import { NumericFormat } from "react-number-format";

function SubmittedOrderPaymentsDetails(props) {
  const { payments } = props;

  const { getValue } = useDictionary();

  if (payments == null) return null;

  return (
    <div className="submitted-order-details-blocks-root">
      {payments.map((payment, index) => (
        <div key={index}>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_orderPayments_agent")}:
            </div>
            <div className="submitted-order-block-data">
              {payment?.info?.provider?.profileTypeName ||
                payment?.paymentAgentID}
            </div>
          </div>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_orderPayments_extID")}:
            </div>
            <div className="submitted-order-block-data">
              {payment?.info?.provider?.transactionId ||
                payment?.extTransactionID}
            </div>
          </div>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {payment?.amount === 0
                ? getValue("app_v2_orderPayments_canceled")
                : getValue("app_v2_orderPayments_amount") + ":"}
            </div>
            <div className="submitted-order-block-data">
              <NumericFormat
                value={+payment?.amount}
                decimalSeparator=","
                suffix=" Ft"
                thousandSeparator="."
                displayType="text"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SubmittedOrderPaymentsDetails;
